/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AINA Agents API
 * Subset of AI agents service used by One App (session APIs).
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  GetLatestExamDetailsParams,
  GetLatestExamDetailsRequestBody,
  GetLatestExamDetailsResponse,
  HTTPValidationError,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns the student's latest exam details. Host apps should call with `clientName: "aina"` and base URL `VITE_AINA` (e.g. https://aiagentsdev.devinfinitylearn.in/api/v1).
 * @summary Get latest exam details
 */
export const getLatestExamDetails = (
  params: GetLatestExamDetailsParams,
  getLatestExamDetailsRequestBody?: GetLatestExamDetailsRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetLatestExamDetailsResponse>(
    {
      url: `/common/get-latest-exam-details`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getLatestExamDetailsRequestBody,
      params,
      signal,
    },
    options,
  );
};

export const getGetLatestExamDetailsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getLatestExamDetails>>,
    TError,
    {
      params: GetLatestExamDetailsParams;
      data: GetLatestExamDetailsRequestBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getLatestExamDetails>>,
  TError,
  { params: GetLatestExamDetailsParams; data: GetLatestExamDetailsRequestBody },
  TContext
> => {
  const mutationKey = ["getLatestExamDetails"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getLatestExamDetails>>,
    {
      params: GetLatestExamDetailsParams;
      data: GetLatestExamDetailsRequestBody;
    }
  > = (props) => {
    const { params, data } = props ?? {};

    return getLatestExamDetails(params, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetLatestExamDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getLatestExamDetails>>
>;
export type GetLatestExamDetailsMutationBody = GetLatestExamDetailsRequestBody;
export type GetLatestExamDetailsMutationError = HTTPValidationError;

/**
 * @summary Get latest exam details
 */
export const useGetLatestExamDetails = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getLatestExamDetails>>,
      TError,
      {
        params: GetLatestExamDetailsParams;
        data: GetLatestExamDetailsRequestBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getLatestExamDetails>>,
  TError,
  { params: GetLatestExamDetailsParams; data: GetLatestExamDetailsRequestBody },
  TContext
> => {
  const mutationOptions = getGetLatestExamDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
